import { render } from "./faultStatisticsComponent.vue?vue&type=template&id=5f163cdd&scoped=true"
import script from "./faultStatisticsComponent.vue?vue&type=script&lang=js"
export * from "./faultStatisticsComponent.vue?vue&type=script&lang=js"

import "./faultStatisticsComponent.vue?vue&type=style&index=0&id=5f163cdd&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f163cdd"]])

export default __exports__